import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

import { PartyNameModel } from '../model/index';

@Injectable()
export class PartyNameService {
    private headers = new Headers({
       'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'

        //'Content-Type': 'application/x-www-form-urlencoded charset=UTF-8', 'Accept': 'q=0.8;application/json;q=0.9'
    });
    private partyNameUrl = 'api/partyName';  // URL to web api

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getPartyNameList(query: any): Promise<PartyNameModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.partyNameUrl}/partyNameList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

   
    deletePartyName(partyID: any): Promise<PartyNameModel> {
        const url = `${this.partyNameUrl}/deletePartyName`;
        return this.http
            .post(url, $.param({ partyID: partyID }), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as PartyNameModel)
            .catch(this.handleError);
    }

    addUpdatePartyName(partyNameData: any): Promise<PartyNameModel> {

        const url = `${this.partyNameUrl}/addUpdatePartyName`;

        return this.http
            .post(url, $.param(partyNameData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as PartyNameModel)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/partyName.service.ts